import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { Location, DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { ComunidadService, MenuFuncionService, MonedaService, TipoUnidadService, TipoGastoService, UnidadFuncionalService, ConsorcioService, TenantService, ExpensaService, MovimientoService, IncidenciaUsuarioService } from '../../../../src/app/shared/services';
import { Comunidad, MenuFuncionCodes, Moneda, SaveUnidadFuncionalDto, SearchComunidadRequest, Consorcio, UnidadFuncionalGastosPorcentaje, ExpensaUnidadFuncionalGastosPorcentajeRequestDto, TenantFeatureFlags, GetSaldoRequestDto, GetSaldoMonedaDto, SearchIncidenciaUsuarioRequestDto, IncidenciaUsuario,
  SearchConsorcioRequest, SearchMonedaRequest, SearchTipoUnidadRequest, TipoUnidad, UnidadFuncional, UnidadFuncionalTipoGastoPorcentajeItemDto,  SearchTipoGastoRequest, TipoGasto, DialogConfirmRequest, DialogConfirmResponse, LocalStorageKeys
 } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-unidadFuncionalEdit',
  templateUrl: './unidadFuncionalEdit.component.html',
  styleUrls: ['./unidadFuncionalEdit.component.scss']
})

export class UnidadFuncionalEditComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  formGroup: FormGroup;
  ufTipoGastoFormGroup: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoGastoSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isTipoUnidadSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isFileAttaching: boolean = false;
  isAttachmentSearching: boolean = false;
  isTiposGastoPorcentajeSearching: boolean = false;
  isComunidadPorcentajesSearching: boolean = false;
  isSaldosSearching: boolean = false;
  isIncidenciasSearching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  canViewSaldos: boolean = false;
  canViewIncidencias: boolean = false;
  esUsuarioFinal: boolean = false;

  showComunidad: boolean = false;
  msgError: string = "";

  item: UnidadFuncional;

  tipoUnidadesString: string = "";
  comunidadesString: string = "";
  monedasString: string = "";

  tipoUnidadList: TipoUnidad[];
  tipoGastoList: TipoGasto[];
  comunidadList: Comunidad[];
  monedaList: Moneda[];
  consorcioList: Consorcio[];
  ufPorcentajesList: UnidadFuncionalTipoGastoPorcentajeItemDto[];
  saldosList: GetSaldoMonedaDto[];
  incidenciasList: IncidenciaUsuario[];

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    private router: Router,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tipoUnidadService: TipoUnidadService,
    private tipoGastoService: TipoGastoService,
    private comunidadService: ComunidadService,
    private monedaService: MonedaService,
    private consorcioService: ConsorcioService,
    private tenantService: TenantService,
    private expensaService: ExpensaService,
    private incidenciaUsuarioService: IncidenciaUsuarioService,
    private movimientoService: MovimientoService,
    private unidadFuncionalService: UnidadFuncionalService) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_DELETE);

            this.esUsuarioFinal = this.sharedFunctions.esUsuarioFinal();

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.buildUfTipoGastoForm();

    this.getTipoUnidades();
    this.getComunidades();
    this.getMonedas();
    this.getConsorcios();
    this.getTipoGastos();

    this.loadEntity();
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.formGroup = this.formBuilder.group({
      'Codigo': [null, [Validators.required, Validators.maxLength(100)]],
      'Numero': [null, Validators.required],
      'NumeroPartida': [null, Validators.maxLength(100)],
      'TipoUnidad': [null, Validators.required],
      'TipoUnidadId': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'NroPiso': [null],
      'MetrosCuadradosCubiertos': [null],
      'MetrosCuadradosDescubiertos': [null],
      'CantidadAmbientes': [null],
      'FechaEntrega': [null],
      'FechaEscrituracion': [null],
      'MonedaId': [null],
      'Precio': [null],
      'ValuacionFiscal': [null],
      'Observaciones': [null, Validators.maxLength(300)],
      'Activo': [true, Validators.required]
    });
  }

  buildUfTipoGastoForm() {
    this.ufTipoGastoFormGroup = this.formBuilder.group({
      'TipoGastoId': [null, Validators.required],
      'Porcentaje': [null, Validators.required],
      'UnidadFuncionalId': [this.item?.Id],
      'TipoGasto': [null],
      // 'TipoGasto': [null],
      'Id': [0],
      'grid-index': [null]
    });
  }

  puedeVerSaldos() {
    if (!this.tenantFeatureFlags?.HabilitarControlCaja) {
      this.canViewSaldos = false;
      return false;
    }

    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewSaldos = this.canViewSaldos || (data?.Result != null && data?.Result.length > 0);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  onComunidadSelect() {
    if (this.tenantFeatureFlags?.HabilitarControlExpensas)
      this.getComunidadUnidadesFuncionalesPorcentajes(this.formGroup.get("ComunidadId")?.value);
  }

  compareTiposGastos(o1: TipoGasto, o2: TipoGasto): boolean {
    return o1?.Id == o2?.Id;
  }

  getComunidadUnidadesFuncionalesPorcentajes(comunidadId: number) {
    if (comunidadId == null || comunidadId <= 0) {
      this.ufPorcentajesList = [];
      return;
    }

    var r = new ExpensaUnidadFuncionalGastosPorcentajeRequestDto(comunidadId);
    this.isComunidadPorcentajesSearching = true;

    this.expensaService.getUnidadFuncionalGastoPorcentajes(r).subscribe(data => {
      this.isComunidadPorcentajesSearching = false;
      this.ufPorcentajesList = data?.Result?.Porcentajes;
      this.actualizarPorcentajesAcumulados();
      this.grid.refresh();
    },
    (err: HttpErrorResponse) => {
      this.isComunidadPorcentajesSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTipoUnidades() {
    var r = new SearchTipoUnidadRequest(null, null, true, "Nombre", null, null, null, true);
    this.isTipoUnidadSearching = true;

    this.tipoUnidadService.search(r).subscribe(data => {
      this.isTipoUnidadSearching = false;
      if (data != null) {
        this.tipoUnidadList = data?.result;
        this.updateTipoUnidadSelection();
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoUnidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  updateTipoUnidadSelection() {
    if (this.tipoUnidadList != null && this.item != null) {
      var tu = this.tipoUnidadList.find(f => f.Id == this.item.TipoUnidadId);

      if (tu != null) {
        this.formGroup.get("TipoUnidad")?.setValue(tu);
        this.onTipoUnidadSelect({ value: tu });
      }
    }
  }

  getTipoGastos() {
    var r = new SearchTipoGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isTipoGastoSearching = true;

    this.tipoGastoService.search(r).subscribe(data => {
      this.isTipoGastoSearching = false;
      if (data != null)
        this.tipoGastoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoGastoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getConsorcios() {
    var p = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(p).subscribe(data => {
      this.isConsorcioSearching = false;
      if (data != null)
        this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var p = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(p).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var p = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(p).subscribe(data => {
      this.isMonedaSearching = false;
      if (data != null)
        this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getSaldos(id) {
    var r = new GetSaldoRequestDto(null, null, null, id, null, null, null);
    this.isSaldosSearching = true;

    this.movimientoService.getSaldo(r).subscribe(data => {
      this.isSaldosSearching = false;
      if (data?.Success)
        this.saldosList = data.Result?.Saldos;
    },
    (err: HttpErrorResponse) => {
      this.isSaldosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          if (this.canView || this.canEdit) {
            this.isSearching = true;
            this.unidadFuncionalService.get(id).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.item = data.Result;
                this.showComunidad = this.item.TipoUnidadRequiereComunidad ?? false;

                if (this.item != null && this.item.Id > 0) {
                  this.puedeVerSaldos();

                  if (this.canEdit) {
                    this.formGroup.patchValue(this.item);
                    this.updateTipoUnidadSelection();

                    if (this.item.FechaEntrega != null)
                      this.formGroup.get("FechaEntrega")?.setValue(this.datePipe.transform(this.item.FechaEntrega, "yyyy-MM-dd"));

                    if (this.item.FechaEscrituracion != null)
                      this.formGroup.get("FechaEscrituracion")?.setValue(this.datePipe.transform(this.item.FechaEscrituracion, "yyyy-MM-dd"));
                  }

                  this.loadAttachments(this.item.Id);
                  this.getSaldos(this.item.Id);

                  if (this.tenantFeatureFlags?.HabilitarControlExpensas) {
                    this.loadTiposGastoPorcentajes(this.item.Id);
                    this.getComunidadUnidadesFuncionalesPorcentajes(this.item.ComunidadId ?? 0);
                  }
                }
                else
                  this.msgError = "No se encontró el item seleccionado.";
              }
              else
                this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else{
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.item = new UnidadFuncional(0, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, [], []);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  loadAttachments(id) {
    this.isAttachmentSearching = true;
    this.unidadFuncionalService.getAttachments(id).subscribe(data => {
      this.isAttachmentSearching = false;
      this.item.Adjuntos = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isAttachmentSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadTiposGastoPorcentajes(id) {
    this.isTiposGastoPorcentajeSearching = true;
    this.unidadFuncionalService.getTipoGastoPorcentajes(id).subscribe(data => {
      this.isTiposGastoPorcentajeSearching = false;
      this.item.GastosPorcentajes = data.Result;

      this.actualizarPorcentajesAcumulados();
    },
    (err: HttpErrorResponse) => {
      this.isTiposGastoPorcentajeSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
            this.formGroup.get(formFieldName)?.setValue(null);
    }
  }

  onTipoUnidadSelect(event: any) {
    if (event != null) {
      var selectedItem = event.value;
      this.formGroup.get("TipoUnidadId")?.setValue(selectedItem?.Id);

      if (selectedItem != null && selectedItem.Id > 0) {
        this.showComunidad = selectedItem.RequiereComunidad;
        if (selectedItem.RequiereComunidad) {
          this.formGroup.get("ConsorcioId")?.setValue(null);
        }
        else {
          this.formGroup.get("ComunidadId")?.setValue(null);
          this.formGroup.get("NumeroPartida")?.setValue(null);
        }
      }
      else
        this.showComunidad = false;
    }
  }

  actualizarPorcentajesAcumulados() {
    if (this.item.GastosPorcentajes != null && this.item.GastosPorcentajes.length > 0) {
      for (var i=0; i<this.item.GastosPorcentajes.length; i++) {
        this.item.GastosPorcentajes[i].PorcentajeAcumulado = this.calcularPorcentajeAcumuladoComunidad(this.item.GastosPorcentajes[i].TipoGastoId, this.item.GastosPorcentajes[i].Porcentaje);
      }
    }
  }

  calcularPorcentajeAcumuladoComunidad(tipoGastoId: number, ufPorcentaje: number): number {
    var valorTotal = 0;
    if (this.ufPorcentajesList != null && this.ufPorcentajesList.length > 0) {
      for (var i=0; i<this.ufPorcentajesList.length; i++) {
        valorTotal += this.ufPorcentajesList[i].TipoGastoPorcentajes
                      .filter(item => item.UnidadFuncionalId  != this.item.Id && item.TipoGastoId == tipoGastoId)
                      .reduce((sum, current) => sum + current.Porcentaje, 0);
      }
    }

    return valorTotal + ufPorcentaje;
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNumero() {
    return this.formGroup.get('Numero')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorTipoUnidad() {
   return this.formGroup.get('TipoUnidad')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorNumeroPartida() {
    var v = this.formGroup.get('NumeroPartida');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorComunidad() {
    var v = this.formGroup.get('ComunidadId')?.value;
    if (v == null || v < 0)
      return 'El campo es obligatorio';
    return '';
  }

  getErrorConsorcio() {
    var v = this.formGroup.get('ConsorcioId')?.value;
    if (v == null || v < 0)
      return 'El campo es obligatorio';
    return '';
  }

  getErrorObservaciones() {
    var v = this.formGroup.get('Observaciones');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var tu = this.formGroup.get("TipoUnidad")?.value;
    if (tu == null || tu.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un tipo de unidad para continuar con la operación", "Error");
      return false;
    }
    this.formGroup.get("TipoUnidadId")?.setValue(tu.Id);

    if (tu.RequiereComunidad) {
      var comuId = this.formGroup.get("ComunidadId")?.value;
      if (comuId == null || comuId <= 0) {
        this.sharedFunctions.showMessage("Por el tipo de unidad seleccionado debe seleccionar una comunidad para continuar con la operación", "Error");
        return false;
      }
    }
    else {
      var consorId = this.formGroup.get("ConsorcioId")?.value;
      if (consorId == null || consorId <= 0) {
        this.sharedFunctions.showMessage("Por el tipo de unidad seleccionado debe seleccionar un consorcio para continuar con la operación", "Error");
        return false;
      }
    }

    var r = new SaveUnidadFuncionalDto(0, null, null, null, 0, null, null, null, null, null, null, null, null, null, null, true);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo,
        Adjuntos: this.item?.Adjuntos,
        GastosPorcentajes: this.item?.GastosPorcentajes
      }
    };

    this.isSaving = true;
    this.unidadFuncionalService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  onFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingFileAttachedDelete(item);
    else
      this.onNewFileAttachedDelete(item);
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.item.Adjuntos == null)
        this.item.Adjuntos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
          this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.unidadFuncionalService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                this.item.Adjuntos.push(data.Result.Archivos[i]);
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  onTipoGastoSelect() {
    this.ufTipoGastoFormGroup.get("TipoGastoId")?.setValue(this.ufTipoGastoFormGroup.get("TipoGasto")?.value?.Id);
    // this.ufTipoGastoFormGroup.get("TipoGasto")?.setValue(this.ufTipoGastoFormGroup.get("TipoGasto")?.value?.Nombre);
  }

  onUfTipoGastoAdd() {
    if (!this.ufTipoGastoFormGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var p = this.ufTipoGastoFormGroup.get("Porcentaje")?.value;
    if (p < 0 || p > 100) {
      this.sharedFunctions.showMessage("Debe ingresar un porcentaje mayor a 0 y menor o igual que 100", "Error");
      return false;
    }

    if (this.item.GastosPorcentajes == null)
      this.item.GastosPorcentajes = [];

    var tgId = this.ufTipoGastoFormGroup.get("TipoGasto")?.value?.Id;
    if (tgId == null || tgId <= 0) {
      var porcentaje = this.ufTipoGastoFormGroup.get("Porcentaje")?.value;

      // const dialogRef = this.dialog.open(DialogConfirmComponent, {
      //   data: new DialogConfirmRequest
      //   (
      //     "Edición de Unidad Funcional",
      //     "¿Está seguro que desea agregar el mismo porcentaje para todos los tipos de gasto?",
      //     "Sí, agregar a todos",
      //     "No"
      //   )
      // });

      // dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {

        // if (result != null && result.Accepted) {
          for (var i=0; i < this.tipoGastoList.length; i++) {
            var index2 = this.item.GastosPorcentajes.findIndex(f => f.TipoGastoId == this.tipoGastoList[i].Id);

            if (index2 >= 0) {
              this.item.GastosPorcentajes[index2].Porcentaje = porcentaje;
              this.item.GastosPorcentajes[index2].TipoGastoId = this.tipoGastoList[i].Id;
              this.item.GastosPorcentajes[index2].TipoGasto = this.tipoGastoList[i].Nombre;
            }
            else {
              this.item.GastosPorcentajes.push(new UnidadFuncionalGastosPorcentaje
                (
                  0,
                  this.tipoGastoList[i].Id,
                  this.tipoGastoList[i].Nombre,
                  porcentaje,
                  0,
                  this.item.Id,
                  null,
                  null,
                  ''
                ));

              index2 = this.item.GastosPorcentajes.length - 1;
            }

            this.item.GastosPorcentajes[index2].PorcentajeAcumulado = this.calcularPorcentajeAcumuladoComunidad((this.ufTipoGastoFormGroup?.get("TipoGasto")?.value?.Id ?? 0), (this.ufTipoGastoFormGroup?.get("Porcentaje")?.value ?? 0));
          }

          this.grid.refresh();
          this.buildUfTipoGastoForm();
      //   }
      //   else {
      //     this.sharedFunctions.showMessage("Debe seleccionar un tipo de gasto para evitar realizar una carga masiva de porcentajes", "Error");
      //     return false;
      //   }
      // });
    }
    else {
      var gridIndex = this.ufTipoGastoFormGroup.get("grid-index")?.value ?? -1;
      if (gridIndex < 0)
        gridIndex = this.item.GastosPorcentajes.findIndex(f => f.TipoGastoId == tgId);

      if (gridIndex >= 0) {
        this.item.GastosPorcentajes[gridIndex].Porcentaje = this.ufTipoGastoFormGroup.get("Porcentaje")?.value;
        this.item.GastosPorcentajes[gridIndex].TipoGastoId = this.ufTipoGastoFormGroup.get("TipoGasto")?.value?.Id;
        this.item.GastosPorcentajes[gridIndex].TipoGasto = this.ufTipoGastoFormGroup.get("TipoGasto")?.value?.Nombre;
      }
      else {
        this.item.GastosPorcentajes.push(new UnidadFuncionalGastosPorcentaje
          (
            0,
            this.ufTipoGastoFormGroup.get("TipoGasto")?.value?.Id,
            this.ufTipoGastoFormGroup.get("TipoGasto")?.value?.Nombre,
            this.ufTipoGastoFormGroup.get("Porcentaje")?.value,
            0,
            this.item.Id,
            null,
            null,
            ''
          ));

        gridIndex = this.item.GastosPorcentajes.length - 1;
      }

      this.item.GastosPorcentajes[gridIndex].PorcentajeAcumulado = this.calcularPorcentajeAcumuladoComunidad((this.ufTipoGastoFormGroup?.get("TipoGasto")?.value?.Id ?? 0), (this.ufTipoGastoFormGroup?.get("Porcentaje")?.value ?? 0));
    }

    this.grid.refresh();
    this.buildUfTipoGastoForm();
  }

  getErrorTipoGasto() {
    var v = this.ufTipoGastoFormGroup.get('TipoGastoId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorPorcentaje() {
    var v = this.ufTipoGastoFormGroup.get('Porcentaje');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    // if (v?.hasError('maxlength'))
    //   return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  onUfTipoGastoView(item: any) {
    if (item != null) {
      this.ufTipoGastoFormGroup.get("TipoGastoId")?.setValue(item.TipoGastoId);
      this.ufTipoGastoFormGroup.get("Porcentaje")?.setValue(item.Porcentaje);
      this.ufTipoGastoFormGroup.get("UnidadFuncionalId")?.setValue(item.UnidadFuncionalId);
      this.ufTipoGastoFormGroup.get("TipoGasto")?.setValue(item.TipoGasto);
      this.ufTipoGastoFormGroup.get("Id")?.setValue(item.Id);

      if (this.tipoGastoList != null)
        this.ufTipoGastoFormGroup.get("TipoGasto")?.setValue(this.tipoGastoList.find(i => i.Id == item.TipoGastoId));

      this.ufTipoGastoFormGroup.get("grid-index")?.setValue(item.index);
    }
  }

  onUfTipoGastoDelete(item: any) {
    if (item != null && item.index >= 0) {
      if (this.item.GastosPorcentajes == null)
        this.item.GastosPorcentajes = [];

      this.item.GastosPorcentajes.splice(item.index, 1);
      this.grid.refresh();
    }
  }

  onDelete() {
    if (!this.canDelete)
      return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el item?", null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.unidadFuncionalService.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  //#region Incidencias

  getIncidencias(id: number) {
    var r = new SearchIncidenciaUsuarioRequestDto(null, null, true, "FechaUltimoMensaje", null, null, null, null, null, null, null, null, null, null, null, id, null, null, null, null);
    this.isIncidenciasSearching = true;

    this.incidenciaUsuarioService.search(r).subscribe(data => {
      this.isIncidenciasSearching = false;
      this.incidenciasList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isIncidenciasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  viewIncidencia(id: number) {
    if (id == null || id <= 0) {
        this.sharedFunctions.showMessage("Debe seleccionar un incidente para continuar", "Error");
        return false;
    }

    this.router.navigate(['incidencia-usuario-edit', id]);
  }

  puedeVerIncidencias() {
    this.menuService.checkMenu(MenuFuncionCodes.INCIDENCIA_USUARIO_LIST).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewIncidencias = this.canViewIncidencias || data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenu(MenuFuncionCodes.INCIDENCIA_USUARIO_LIST_BO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewIncidencias = this.canViewIncidencias || data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

//#endregion
}
